import { useEffect, useState } from 'react';

export interface GeoPrice {
  currency: string;
  amount: number;
  price: string;
  originalPrice: string;
}

const AR_PRICE: GeoPrice = {
  currency: 'ARS',
  amount: 19990,
  price: 'ARS 19.990',
  originalPrice: 'ARS 39.990'
};

const USD_PRICE: GeoPrice = {
  currency: 'USD',
  amount: 14.99,
  price: 'USD 14.99',
  originalPrice: 'USD 29.99'
};

/**
 * Detecta el país del visitante por IP con una API gratuita (ipapi.co).
 * Argentina → precio en ARS. Resto del mundo (o si falla la detección) → USD.
 */
export function useGeoPrice(): {
  price: GeoPrice;
  isLoading: boolean;
} {
  const [price, setPrice] = useState<GeoPrice>(USD_PRICE);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);

    const detect = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/', {
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Geolocation request failed');
        const data: {
          country_code?: string;
        } = await response.json();
        if (cancelled) return;
        setPrice(data.country_code === 'AR' ? AR_PRICE : USD_PRICE);
      } catch {
        // Si la detección falla, se mantiene el precio en USD.
        if (!cancelled) setPrice(USD_PRICE);
      } finally {
        clearTimeout(timeout);
        if (!cancelled) setIsLoading(false);
      }
    };

    detect();

    return () => {
      cancelled = true;
      clearTimeout(timeout);
      controller.abort();
    };
  }, []);

  return {
    price,
    isLoading
  };
}
